import { logError } from './../Analytics/AnalyticsClient';
import { AppUser, Permissions, UserRole } from './authTypes';

export const getRoleBasedRedirectUrlLegacy = (role: UserRole | undefined): string => {
  if (!role) {
    logError('Missing user role for legacy redirect in getRoleBasedRedirectUrlLegacy');
    return '/500';
  }
  const redirect = {
    [UserRole.InstitutionUser]: '/orders/new',
    [UserRole.OrdersUser]: '/orders/new',
    [UserRole.ResultsUser]: '/orders',
  };
  switch (role) {
    case UserRole.InstitutionUser: {
      return redirect[UserRole.InstitutionUser];
    }
    case UserRole.OrdersUser: {
      return redirect[UserRole.OrdersUser];
    }
    case UserRole.ResultsUser: {
      return redirect[UserRole.ResultsUser];
    }
    default:
      return redirect[UserRole.InstitutionUser];
  }
};
export const getRoleBasedRedirectUrl = (user: AppUser): string => {
  if (user.kariusPermissions && user.kariusPermissions.length > 0) {
    if (user.kariusPermissions.includes(Permissions.CreateOrder)) {
      return '/orders/new';
    }
    return '/orders';
  }
  return `/403`;
};
